import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeComponent } from '@home/home.component';
import { HomeBackofficeComponent } from '@home/home-backoffice.component';
import { Authority } from '@constants/authority.constants';
import { TutorialsComponent } from '@home/tutorials.component';
import { HomeEntityComponent } from '@home/home-entity.component';
import { HomeYoungComponent } from '@home/home-young.component';
import { NewsComponent } from '@home/news.component';
import { ProgramNewsResolve } from '@programs/program-news/program-news.route';
import { InstitutionComponent } from '@home/institution/institution.component';
import { ProfileComponent } from '@home/profile/profile.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: HomeComponent,
        data: {
          authorities: [],
          pageTitle: 'home.title'
        }
      },
      {
        path: 'back-office',
        component: HomeBackofficeComponent,
        data: {
          authorities: [Authority.BACKOFFICE],
          pageTitle: 'home.title',
          breadcrumb: { alias: 'homeBackoffice' }
        }
      },
      {
        path: 'tutorials',
        component: TutorialsComponent
      },
      {
        path: 'entity',
        component: HomeEntityComponent,
        data: {
          authorities: [Authority.SYSTEM],
          pageTitle: 'home.title'
        }
      },
      {
        path: 'young',
        component: HomeYoungComponent,
        data: {
          authorities: [Authority.USER],
          pageTitle: 'home.title',
          breadcrumb: { alias: 'homeYoung' }
        }
      },
      {
        path: 'news/:id',
        component: NewsComponent,
        resolve: {
          record: ProgramNewsResolve
        },
        data: {
          authorities: [],
          pageTitle: 'home.title'
        }
      },
      {
        path: 'institution',
        component: InstitutionComponent,
        data: {
          authorities: [],
          pageTitle: 'institution.title',
          breadcrumb: 'Instituições'
        }
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: {
          authorities: [],
          pageTitle: 'profile.title',
          breadcrumb: 'Perfil'
        }
      }
    ])
  ]
})
export class HomeModule {}
